import {
  EntityContentBlueprint,
  EntityHeaderLayoutBlueprint,
} from '@backstage/plugin-catalog-react/alpha';

const accountOverviewTabContent = EntityContentBlueprint.make({
  name: 'account',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: { kind: 'account' },
    loader: () =>
      import('@internal/backstage-plugin-catalog-devops').then(
        m => <m.AccountOverviewTab />,
      ),
  },
});

const groupOverviewTabContent = EntityContentBlueprint.make({
  name: 'group',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: { kind: 'group' },
    loader: () =>
      import('./GroupOverviewTab').then(m => <m.GroupOverviewTab />),
  },
});

const userOverviewTabContent = EntityContentBlueprint.make({
  name: 'user',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: { kind: 'user' },
    loader: () => import('./UserOverviewTab').then(m => <m.UserOverviewTab />),
  },
});

const generalOverviewTabContent = EntityContentBlueprint.make({
  name: 'general',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: {
      $not: {
        kind: {
          $in: [
            'group',
            'user',
            'account',
            'CloudResource',
            'ClusterResource',
            'Cluster',
            'Integration',
            'Domain',
            'RuleSet',
            'Rule',
            'Insight',
          ],
        },
      },
    },
    loader: () =>
      import('./GeneralOverviewTab').then(m => <m.GeneralOverviewTab />),
  },
});

const accountHeader = EntityHeaderLayoutBlueprint.make({
  name: 'account-header',
  params: {
    filter: { kind: 'account' },
    loader: () =>
      import('@internal/backstage-plugin-catalog-devops').then(
        m => m.AccountPageHeader,
      ),
  },
});

const projectHeader = EntityHeaderLayoutBlueprint.make({
  name: 'project-header',
  params: {
    filter: { kind: 'domain' },
    loader: () => import('@internal/backstage-plugin-catalog-devops').then(
        m => m.ProjectPageHeader,
      ),
  },
});

const projectOverviewTabContent = EntityContentBlueprint.make({
  name: 'project-overview',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: { kind: 'domain' },
    loader: () =>
      import('@internal/backstage-plugin-catalog-devops').then(
        m => <m.ProjectOverviewTab />,
      ),
  },
});

// Per-kind headers for the catalog child kinds (design/*-page-mockup.html):
// the same KindPageHeader component, one blueprint per kind.
const ruleHeader = EntityHeaderLayoutBlueprint.make({
  name: 'rule-header',
  params: {
    filter: { kind: 'rule' },
    loader: () => import('@internal/backstage-plugin-catalog-devops').then(
        m => m.KindPageHeader,
      ),
  },
});

const cloudResourceHeader = EntityHeaderLayoutBlueprint.make({
  name: 'cloud-resource-header',
  params: {
    filter: { kind: 'cloudresource' },
    loader: () => import('@internal/backstage-plugin-catalog-devops').then(
        m => m.KindPageHeader,
      ),
  },
});

const ruleSetHeader = EntityHeaderLayoutBlueprint.make({
  name: 'rule-set-header',
  params: {
    filter: { kind: 'ruleset' },
    loader: () => import('@internal/backstage-plugin-catalog-devops').then(
        m => m.KindPageHeader,
      ),
  },
});

const insightHeader = EntityHeaderLayoutBlueprint.make({
  name: 'insight-header',
  params: {
    filter: { kind: 'insight' },
    loader: () => import('@internal/backstage-plugin-catalog-devops').then(
        m => m.KindPageHeader,
      ),
  },
});

export default [
  accountHeader,
  projectHeader,
  ruleHeader,
  cloudResourceHeader,
  ruleSetHeader,
  insightHeader,
  projectOverviewTabContent,
  accountOverviewTabContent,
  groupOverviewTabContent,
  userOverviewTabContent,
  generalOverviewTabContent,
];
